<template>
  <div class="article-slot__wrapper">
    <a-media
      :image="article.featuredImage"
      :image-aspect-ratio="$options.consts.aspectRatios.article"
      :video="article.featuredVideo"
      :video-aspect-ratio="$options.consts.aspectRatios.article"
      :url="article.canonicalUrl"
      :rounded="true"
      class="article-slot__featured-media"
    />
    <div class="article-slot__text-content-wrapper">
      <a-dots-responsive
        :text="article.title"
        :tag="$options.consts.HTML_TAG.HEADING_H4"
        :link-props="{ to: article.canonicalUrl }"
        :settings="$options.consts.topicSettings"
        class="article-slot__article-title"
      />
      <time class="article-slot__timestamp">
        {{ publishDate }}
      </time>
    </div>
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import AMedia from 'shared/AMedia'
import { aspectRatios } from 'enums/aspectRatios'
import { HTML_TAG } from '@fmpedia/enums'
import ADotsResponsive, { configADots } from 'shared/ADotsResponsive'
import scss from '@/utils/scss'

const { breakpoints } = scss

export default {
  name: 'AArticleSlotMoreFromTheAuthor',
  components: { ADotsResponsive, AMedia },
  props: {
    article: propValidator([PROP_TYPES.OBJECT]),
    showTldr: propValidator([PROP_TYPES.BOOLEAN], false, true)
  },
  consts: {
    aspectRatios,
    HTML_TAG,
    topicSettings: {
      [breakpoints.aboveDesktopXl]: configADots(5, 22, true),
      [breakpoints.desktopXl]: configADots(4, 18, true),
      [breakpoints.desktopLg]: configADots(4, 22, true),
      [breakpoints.desktopMd]: configADots(4, 18, true),
      [breakpoints.mobile]: configADots(5, 22, false)
    }
  },
  computed: {
    publishDate() {
      return this.$helper.formatDate.toDefault(this.article.publishedOn)
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/scss/local/mixins/grid';
@import '~assets/scss/local/styles/article';

.article-slot__wrapper {
  $grid-setup: (
    $columnSetup: (
      $above-desktop-xl: repeat(2, minmax(0, 100%)),
      $mobile: minmax(0, 100%)
    ),
    $columnGapSetup: (
      $above-desktop-xl: 15px
    ),
    $rowGapSetup: (
      $mobile: 15px
    )
  );

  @include gridBuilder($grid-setup);

  .article-slot__text-content-wrapper {
    display: flex;
    flex-direction: column;
    padding: 5px 0 5px;
  }

  .article-slot__article-title {
    @extend .article-slot-title;
  }

  .article-slot__timestamp {
    display: block;
    $margin-top: (
      $above-desktop-xl: auto,
      $mobile: 10px
    );

    @extend .timestamp;
    @include setStyleByBreakpoint('margin-top', $margin-top);
  }
}
</style>
